import React from 'react'
import { isEmptyList } from '../../../utils'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'

export default function HotSwapEmptyListMessage({ list, isLoading }) {
    const { locale } = useSelector(state => state.main)
    const classes = useStyles()

    return (
        <>
            {isEmptyList(list) && !isLoading && (
                <div className={classes.emmptyListMessage}>
                    <span>{locale.hotSwap.hotSwapTableEmptyListMessage}</span>
                </div>
            )}
        </>
    )
}

const useStyles = makeStyles(() => ({
    emmptyListMessage: {
        display: 'flex',
        alignSelf: 'center'
    }
}))
